import { render, staticRenderFns } from "./PurchasePaymentDisplayView.vue?vue&type=template&id=259743da"
import script from "./PurchasePaymentDisplayView.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports